import { render, staticRenderFns } from "./OrderDetailInfo.vue?vue&type=template&id=474b7c3e&scoped=true"
import script from "./OrderDetailInfo.vue?vue&type=script&lang=js"
export * from "./OrderDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailInfo.vue?vue&type=style&index=0&id=474b7c3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b7c3e",
  null
  
)

export default component.exports